import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const BUSINESS_UNIT_ENDPOINT = {
  USER_ASSOCIATED_BU_LIST: {
    method: EMethod.GET,
    url: "/bu/associated",
    version: API_VERSION.V0,
  },
  CHECK_ASSIGNMENT_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/assignment/check",
    version: API_VERSION.V0,
  },
  GET_BU_DETAIL: {
    method: EMethod.GET,
    url: "/bu",
    version: API_VERSION.V0,
  },
  GET_BU_EMPLOYEE_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/employee",
    version: API_VERSION.V0,
  },
  GET_EMPLOYEE_ACCESS: {
    method: EMethod.GET,
    url: "/bu/member/employee/access",
    version: API_VERSION.V0,
  },
  GET_BU_STAFF_MEMBER_FILTER: {
    method: EMethod.GET,
    url: "/bu/member/staff/filter",
    version: API_VERSION.V0,
  },
  GET_BU_STAFF_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/staff",
    version: API_VERSION.V0,
  },
  GET_BU_CLIENT_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/client",
    version: API_VERSION.V0,
  },
  GET_BU_CORPORATION_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/corporation",
    version: API_VERSION.V0,
  },
  GET_CORP_MEMBER_FILTER: {
    method: EMethod.GET,
    url: "/bu/member/corporation/filter",
    version: API_VERSION.V0,
  },
  GET_BU_STAFF_NOTES: {
    method: EMethod.GET,
    url: "/bu/member/notes",
    version: API_VERSION.V0,
  },
  UPDATE_BU_STAFF_NOTES: {
    method: EMethod.PUT,
    url: "/bu/member/notes",
    version: API_VERSION.V0,
  },
  GET_MANUAL_JOB_SUGGESTION: {
    method: EMethod.POST,
    url: "/bu/job/manual-suggestion/get",
    version: API_VERSION.V0,
  },
  GET_FILTER_MANUAL_JOB_SUGGESTION: {
    method: EMethod.GET,
    url: "/bu/job/manual-suggestion/filter",
    version: API_VERSION.V0,
  },
  GET_AI_JOB_SUGGESTION: {
    method: EMethod.POST,
    url: "/bu/job/ai-suggestion/get",
    version: API_VERSION.V0,
  },
  GENERATE_AI_JOB_SUGGESTION: {
    method: EMethod.POST,
    url: "/bu/ai/job-match",
    version: API_VERSION.V0,
  },
  GET_PROGRESS_GENERATE_AI_JOB_SUGGESTION: {
    method: EMethod.GET,
    url: "/bu/ai/progress",
    version: API_VERSION.V0,
  },
  GET_STAFF_MATCHING: {
    method: EMethod.POST,
    url: "/bu/job/staff-match/get",
    version: API_VERSION.V0,
  },
  GET_STAFF_MATCHING_FILTER: {
    method: EMethod.GET,
    url: "/bu/job/staff-match/filter",
    version: API_VERSION.V0,
  },
  GET_COMPANY_MATCHING: {
    method: EMethod.POST,
    url: "/bu/job/company-match/get",
    version: API_VERSION.V0,
  },
  GET_COMPANY_MATCHING_FILTER: {
    method: EMethod.GET,
    url: "/bu/job/company-match/filter",
    version: API_VERSION.V0,
  },
  GET_BU_EMPLOYEE_MEMBER_FILTER: {
    method: EMethod.GET,
    url: "/bu/member/employee/filter",
    version: API_VERSION.V0,
  },
};
